import {decorateStyleIntent} from './intents';
import {StyleCache} from './StyleCache';
import type {Style} from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createStyleIntent<Args extends any[]>(
  layer: Style.Layer,
  createKey: (...args: Args) => string,
  createLazyStyles: (...args: Args) => Style.LazyStylesFunction,
): (...args: Args) => Style.Intent {
  return (...args: Args) => {
    const key = createKey(...args);
    const cached = StyleCache.get(key);
    if (cached) {
      return cached;
    }

    const lazy = createLazyStyles(...args) as Style.LazyStyles;
    lazy.key = key;
    lazy.layer = layer;
    const intent = decorateStyleIntent(lazy);
    StyleCache.register(intent);
    return intent;
  };
}
